export const sortFilter = {
  '': 'Most Suitable',
  best_seller: 'Best Seller',
  price: 'Price',
  name: 'Name',
};
